import {
  // LOGIN,
  PROFILE,
} from 'router/routes'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {logout} from 'store/actions/auth'
import {toAbsoluteUrl} from 'helpers'
import {logoutSession} from 'services/api/actions'
import {parseError} from 'utils'

const HeaderUserMenu = ({user, show}) => {
  const dispatch = useDispatch()

  const onLogout = async () => {
    try {
      await logoutSession()
    } catch (error) {
      console.log(parseError(error))
    }
    dispatch(logout())
    // setTimeout(() => {
    //   window.location.href = LOGIN
    // }, 0)
  }

  return (
    <div
      className={`menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-275px${show ? ' show' : ''}`}
      data-kt-menu='true'
      style={{
        position: 'fixed',
        inset: '0px 0px auto auto',
        margin: '0px',
        transform: 'translate(-30px, 65px)',
      }}
    >
      <div className='menu-item px-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='symbol symbol-50px me-5'>
            <img alt='Logo' src={user.image || toAbsoluteUrl('/media/avatars/blank.png')} />
          </div>

          <div className='d-flex flex-column'>
            <div className='fw-bolder d-flex align-items-center fs-5'>{user.name || ''}</div>
            <div className='fw-bold text-muted text-hover-primary fs-7'>{user.email || ''}</div>
          </div>
        </div>
      </div>

      <div className='separator my-2' />

      <div className='menu-item px-5'>
        <Link to={PROFILE} className='menu-link px-5'>
          My Profile
        </Link>
      </div>

      <div className='menu-item px-5'>
        <div onClick={onLogout} className='menu-link px-5'>
          Sign Out
        </div>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
